export enum OrderSourceEnum {
  PARTIAL_PAYMENT = 'PartialPayment',
  TABLE = 'Table',
  GUEST_TABLE = 'GuestTable',
  PARTIAL_CARD_PAYMENT = "PartialCardPayment"
}
